var _path;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgReferral(_ref, svgRef) {
  let title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 14,
    height: 14,
    viewBox: "0 0 14 14",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M5.25025 8.74985L8.75025 5.24985M6.41692 3.49985L6.687 3.18719C7.23405 2.64021 7.97599 2.33295 8.74958 2.33301C9.52318 2.33306 10.2651 2.64042 10.812 3.18748C11.359 3.73453 11.6663 4.47646 11.6662 5.25006C11.6662 6.02365 11.3588 6.76554 10.8118 7.31252L10.5002 7.58319M7.58358 10.4999L7.352 10.8114C6.79841 11.3583 6.05153 11.6651 5.27329 11.6651C4.49505 11.6651 3.74817 11.3583 3.19458 10.8114C2.92165 10.5417 2.70496 10.2206 2.55706 9.86653C2.40916 9.51251 2.33301 9.13265 2.33301 8.74898C2.33301 8.3653 2.40916 7.98545 2.55706 7.63142C2.70496 7.2774 2.92165 6.95626 3.19458 6.6866L3.50025 6.41652",
    stroke: "#FFBF29",
    strokeWidth: 1.16667,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgReferral);
export default __webpack_public_path__ + "static/media/referral.53ea91ce1c695bcfc1e43db7b063cf08.svg";
export { ForwardRef as ReactComponent };